import { render, staticRenderFns } from "./CustomerChoosePack.vue?vue&type=template&id=277c0a6e"
import script from "./CustomerChoosePack.vue?vue&type=script&lang=js"
export * from "./CustomerChoosePack.vue?vue&type=script&lang=js"
import style0 from "./CustomerChoosePack.vue?vue&type=style&index=0&id=277c0a6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports